<template>
  <div class="content">
    <h2 class="text-2xl font-bold mb-4">Wheel Behavior</h2>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">How does the wheel spin?</h3>
      <p>The wheel uses physics-based animation to create a realistic spinning effect. When you trigger a spin,
        the wheel accelerates to a random speed, then gradually decelerates until it stops on a random selection.
        The animation has been improved to be both visually appealing and fair in its selection process.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Can I control the spin duration?</h3>
      <p>Yes, you can adjust the spin duration in the wheel settings. You can choose from preset durations or
        customize it to your preference. Longer spins build more anticipation, while shorter spins are useful when
        you need to make quick selections.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">What happens when the wheel stops?</h3>
      <p>When the wheel stops, the winning selection is highlighted and, depending on your settings, several
        things may happen:</p>
      <ul class="list-disc ml-6 mt-2">
        <li>A celebratory animation may play</li>
        <li>A sound effect may play</li>
        <li>A dialog box may appear showing the winner</li>
        <li>Confetti may be displayed</li>
        <li>The winner may be automatically removed from the wheel (if enabled)</li>
      </ul>
      <p class="mt-2">All these behaviors can be customized in the wheel settings.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Can the wheel be rigged or weighted?</h3>
      <p>No, the wheel uses a fair random selection algorithm. Every entry has an equal chance of being selected
        unless you've added the same entry multiple times (which effectively gives it a higher weight). The
        spinning animation is purely visual and doesn't influence the randomness of the selection.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Can I stop the wheel manually?</h3>
      <p>No, once the wheel starts spinning, it will continue until it naturally stops at a random position. This
        ensures fairness in the selection process and prevents manipulation of results.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Why does my wheel sometimes appear to slow down before speeding up
        again?</h3>
      <p>This is part of the physics-based animation that creates a more realistic spinning experience. The
        wheel's deceleration isn't perfectly linear, which adds to the suspense and visual appeal of the spinning
        process.</p>
    </div>

    <p class="mt-8 text-sm"><a href="#top" class="text-blue-500 hover:underline">Back to top</a></p>
  </div>
</template>

<script setup>
import '@components/ui/faq/faqStyles.css';
</script>
